module.exports = __webpack_public_path__ + "static/media/data-in-analysis-out-infographic.5632687d.png";